import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useMemo } from 'react';
import { useAcquisitionContext } from '~/context/common/AcquisitionContext';
import { useFactoryUpgradesQuali } from '~/context/common/FactoryUpgradesQualiContext';
import { useConsumer } from '~/context/common/StaticContext';
import {
  useHasTrades,
  useIsTradeInApplied
} from '~/context/common/TradeContext';
import { useIsLoggedIn, useUserLocation } from '~/context/common/UserContext';
import { useHasValidSoftPull } from '~/context/home/FinanceContext';
import HomeModalContext from '~/context/home/ModalContext';

export default function useTileSharedProps() {
  const { captureEngagement } = useFactoryUpgradesQuali();
  const consumer = useConsumer();
  const hasSoftPull = useHasValidSoftPull();
  const { isFinanceRestricted } = useAcquisitionContext();
  const isLoggedIn = useIsLoggedIn();
  const isTradeInApplied = useIsTradeInApplied();
  const { setMoreDetailsModalOpen } = useContext(HomeModalContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const userHasTrades = useHasTrades();
  const userLocation = useUserLocation();

  const isUserWithTrades = userHasTrades && isLoggedIn;

  return useMemo(
    () => ({
      captureEngagement,
      consumer,
      hasSoftPull,
      isFinanceRestricted,
      isLoggedIn,
      isTradeInApplied,
      isUserWithTrades,
      setMoreDetailsModalOpen,
      trackEvent,
      userLocationState: userLocation.state
    }),
    [
      captureEngagement,
      consumer,
      hasSoftPull,
      isFinanceRestricted,
      isLoggedIn,
      isTradeInApplied,
      isUserWithTrades,
      setMoreDetailsModalOpen,
      trackEvent,
      userLocation.state
    ]
  );
}

export type TileSharedProps = ReturnType<typeof useTileSharedProps>;
